module.exports = __webpack_public_path__ + "static/media/EVZ.F_BIG.D.97b681e3.svg";